module.exports = __webpack_public_path__ + "static/img/4.3faa18b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/eng/4.png
// module id = CNiv
// module chunks = 0